import { NgClass, NgComponentOutlet, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';

import type { NbxDialogEntry } from './nbx-dialog.service';
import { NbxDialogService } from './nbx-dialog.service';

/**
 * Root-level outlet that renders all active dialogs managed by {@link NbxDialogService}.
 * Add `<nbx-dialog-outlet />` once at the bottom of `AppComponent`'s template.
 */
@Component({
  selector: 'nbx-dialog-outlet',
  standalone: true,
  imports: [NgClass, NgComponentOutlet, NgStyle],
  templateUrl: './nbx-dialog-outlet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbxDialogOutletComponent {
  protected readonly _service = inject(NbxDialogService);

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    const stack = this._service.dialogs();
    if (stack.length === 0) {
      return;
    }
    const top = stack[stack.length - 1];
    if (top.config.closable !== false) {
      top.ref.close();
    }
  }

  onBackdropClick(entry: NbxDialogEntry): void {
    if (entry.config.closable !== false) {
      entry.ref.close();
    }
  }
}
